const { createSelector } = require('reselect');

const selectPersonInformation = createSelector(
  state => state.person?.person,
  person => person
);

export default { selectPersonInformation };
